import ms from '../JsonLang/ms.json'
export const lang = { ...ms }